import { LBButton } from '@linearb/buzz';
import { Flex } from '../base/layout-components';
import Text from '../base/Text';
import { navigateBookDemoClick } from 'common/utils/utils';

const ButtonLine = ({ leftText, buttonText, onClickEvent, textWidth }) => {
  return (
    <Flex width='calc(100% - 2rem)'>
      <Flex items='center' justify='space-between' width='100%'>
        <Text
          size='x-x-x-larger'
          color='chambray'
          weight='800'
          width={textWidth}
        >
          {leftText}
        </Text>
        <LBButton
          size='lg'
          onClick={() => {
            onClickEvent();
            navigateBookDemoClick();
          }}
        >
          <Text color='white' size='x-x-larger' weight='800' padding='1.2rem 0'>
            {buttonText}
          </Text>
        </LBButton>
      </Flex>
    </Flex>
  );
};

export default ButtonLine;
